import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BUDGETS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BUDGETS');
export const BUDGETS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BUDGETS_CRUD_ACTION_CONSTANTS
);
